"use client";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import {
  floatingAmountSx,
  floatingCartCategoryCardSx,
  floatingSaveSx,
  viewCartButtonSx,
} from "./floatingCartShared";
import { AddToCartService, Cart, MainCart } from "@/app/services/cart";
import Image from "next/image";
import { useCurrencyCode } from "../helper-functions/CurrencySymbol";
import "./index.css";
import { useRouter } from "next/navigation";
import { Loader } from "../MainLoader/Loader";

export const AllCartsSlideCategory = (cid: any) => {
  const addToCartService = useMemo(() => new AddToCartService(), []);
  const [cartByCid, setCartByCid] = useState<Cart | undefined>(undefined);
  const [loading, setLoading] = useState(false);
  const currencyCode = useCurrencyCode();
  const router = useRouter();

  const getAllCarts = useCallback(() => {
    const mainCart: MainCart = addToCartService.getCart();
    if (!mainCart) {
      // console.log("No cart found");
      return;
    }
    const filterCidCart: Cart | undefined = mainCart?.cartItemRequestsById.find(
      (item: any) => item.cid == cid.cid
    );
    setCartByCid(filterCidCart);
  }, [addToCartService, cid]);

  useEffect(() => {
    getAllCarts();
  }, [getAllCarts]);

  useEffect(() => {
    const intr = setInterval(() => {
      getAllCarts();
    }, 1000);
    return () => {
      clearInterval(intr);
    };
  }, [getAllCarts]);

  const NavigateViewCart = (item: any) => {
    setLoading(true);
    router.push("/cart");
    localStorage.setItem("cid", btoa(JSON.stringify(item?.cid)));
  };

  return (
    <>
      {loading && <Loader />}
      {cartByCid && cartByCid?.cartItemRequests?.length > 0 ? (
        <Box sx={floatingCartCategoryCardSx}>
          <Box
            sx={{
              display: "flex !important",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "6px 12px",
            }}
          >
            <Box sx={{ marginRight: "0.5rem" }}>
              <Image
                height={200}
                width={200}
                alt="banner"
                src={cartByCid?.cartItemRequests?.[0]?.ImageUrl ?? ""}
                style={{
                  height: "55px",
                  width: "55px",
                  minWidth: "55px",
                  minHeight: "55px",
                  objectFit: "cover",
                  borderRadius: "50%",
                }}
              />
            </Box>
            <Box>
              <Typography
                sx={{
                  display: "-webkit-box",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "normal",
                  height: "42px",
                  alignContent: "center",
                }}
                variant="caption"
              >
                {cartByCid?.cartItemRequests
                  ?.map((service: any) => service.serviceName)
                  .join(", ")}
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "start",
                  alignItems: "center",
                }}
              >
                <Typography variant="caption" sx={floatingAmountSx}>
                  {currencyCode}
                  {cartByCid?.totalAmount}
                </Typography>
                &nbsp; &nbsp;
                <Typography
                  sx={{
                    textDecoration: "line-through",
                    color: "gray",
                  }}
                  variant="caption"
                >
                  {currencyCode}
                  {cartByCid?.totalMrp}
                </Typography>
                &nbsp; &nbsp;
                <Typography variant="caption" sx={floatingSaveSx}>
                  Save {currencyCode}
                  {cartByCid?.totalDiscount}
                </Typography>
              </Box>
            </Box>
            &nbsp; &nbsp; &nbsp;
            <Box>
              <Button
                variant="outlined"
                sx={viewCartButtonSx}
                onClick={() => NavigateViewCart(cartByCid)}
              >
                View Cart
              </Button>
            </Box>
          </Box>
        </Box>
      ) : (
        ""
      )}
    </>
  );
};
